import React from "react"
import {compose} from "redux"
import {RouteComponentProps} from "react-router"

// HOCs
import withUser, {WithUserProps} from "../../auth/hoc/withUser"
import withRecords, {WithRecordsProps} from "../hoc/withRecords"
import withRecordData, {WithRecordDataProps} from "../hoc/withRecordData"

// Components
import RecordPage from "../components/RecordPageSwitch"

type RecordPreviewPageContainerProps =
    WithUserProps &
    WithRecordsProps &
    WithRecordDataProps &
    RouteComponentProps
/**
 * @param props
 */
function RecordPreviewPageContainer(props: RecordPreviewPageContainerProps) {
    const {match: {params}, fetchRecordById, clearCurrentRecord} = props;

    React.useEffect(() => {
        if (typeof (params as { id: string })["id"] !== "undefined") {
            fetchRecordById((params as { id: string })["id"]);
        }

        return clearCurrentRecord
        // eslint-disable-next-line
    }, []);

    return <RecordPage {...props}/>
}

export default compose(
    withUser,
    withRecords,
    withRecordData,
)(RecordPreviewPageContainer)